<!-- 专题 - 模块设置 -->
<template>
  <div class="page-module-wrap">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="topic-set-module-container">
          <p class="title">模块名称</p>
          <input class="block input width-3" v-model="setModule.title">
          <p class="title">显示状态</p>
          <div class="block">
            <input type="radio" value="1" v-model="status" name="setStatus"><label>永久开启</label>
            <input type="radio" value="0" v-model="status" name="setStatus"><label>永久关闭</label>
            <input type="radio" value="2" v-model="status" name="setStatus"><label>定时开关</label>
          </div>
          <div class="block" v-if="status === 2 || status === '2'">
            <span class="inline-block width-2">
              <el-date-picker
                v-model="setModule.startTime"
                type="datetime"
                placeholder="开始时间">
              </el-date-picker>
            </span>
            <span class="inline-block width-2" style="margin-left: 20px;">
              <el-date-picker
                v-model="setModule.endTime"
                type="datetime"
                placeholder="结束时间">
              </el-date-picker>
            </span>
          </div>
          <div>
          </div>
          <div class="slider-wrap">
            <p class="title">
              与上一模块间距（px）
              <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top-start">
                <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
              </el-tooltip>
            </p>
            <p>
              <el-slider v-model="setModule.marginTop" :max="400" :show-input="true"></el-slider>
            </p>
          </div>
          <div class="slider-wrap">
            <p class="title">
              水平间距（px）
              <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top-start">
                <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
              </el-tooltip>
            </p>
            <p>
              <el-slider v-model="setModule.marginLeft" :max="400" :show-input="true"></el-slider>
            </p>
          </div>
          <p class="title" style="margin-top: 30px;">内容格式</p>
          <div class="block">
            <div class="control">
              <div class="inline-block">
                  <span class="radio r-top">
                    <input type="checkbox" id="" name="shopProp" value="0" v-model="formatTitle" >
                    <label for="storage">显示标题</label>
                  </span>
                  <span class="radio r-top">
                    <input type="checkbox" id="" name="shopProp" value="1" v-model="formatSubTitle" >
                    <label for="onSale">显示副标题</label>
                  </span>
                  <span class="radio r-top">
                    <input type="checkbox" id="" name="shopProp" value="2" v-model="formatTag" >
                    <label for="onSale">显示标签</label>
                  </span>
              </div>
            </div>
          </div>
        </div>
            <div class="inline-block" style="margin: 60px 0 40px 0;">
              <p>
                <button class="button is-primary"  @click="saveModuleClick">保存</button>
              </p>
            </div>
      </article>
        </div>
  </div>
</template>

<script type="text/babel">
  import { formatDate } from 'UTILS/date'

  export default {
    data(){
      return{
        status:1,
        //模块设置
        setModule:{
          title:"",
          status:1,
          marginTop: 20,
          marginLeft: 20,
          startTime: "",
          endTime:"",
          // format: [],
        },
        formatTitle: '',
        formatSubTitle: '',
        formatTag: '',
      }
    },
    computed: {
      
      marginTopPer () {
        return `${this.setModule.marginTop}px`
      },
      marginLeftPer () {
        return `${this.setModule.marginLeft}px`
      }
    },
    mounted(){
      this.getModuleInit();
    },
    methods:{
      formatDate(date) {
        return formatDate(date, "yyyy-MM-dd hh:mm:ss")
      },
      //获取模块设置数据
      getModuleInit(){
        HttpRequest.post("/admin.php?method=main.getTopicAdModule", {}, true).then((response) => {
          this.setModule = response.data;
          this.setModule.marginLeft = this.setModule.marginLeft * 2;
          this.setModule.marginTop = this.setModule.marginTop * 2;
          this.status = response.data.status;
          if ( response.data.status === 1 &&  response.data.startTime > 0 && response.data.endTime > 0) {
            this.status = 2;
          }
          this.setModule.startTime = (response.data.startTime > 0) ? this.formatDate(response.data.startTime) : '';
          this.setModule.endTime = (response.data.endTime > 0) ? this.formatDate(response.data.endTime) : '';
          response.data.format.forEach((item, index) => {
            if (parseInt(item) === 0 ) {
              this.formatTitle = true;
            } else if ( parseInt(item) === 1 ) {
              this.formatSubTitle = true;
            } else {
              this.formatTag = true;
            }
          })
          delete this.setModule.format;
        }, (error) => {

        });
      },
      //保存模块设置
      saveModuleClick(){
        let format = [];
        if (this.formatTitle === true) {
          format.push('0')
        }
        if (this.formatSubTitle === true) {
          format.push('1');
        }
        if (this.formatTag === true) {
          format.push('2');
        }

        this.setModule.status = this.status;
        if ( parseInt(this.status) === 2 ) {
          this.setModule.status = 1;
          let _start = Date.parse(this.setModule.startTime);
          let _end = Date.parse(this.setModule.endTime);
          if ( _end <= _start ) {
            this.$message('结束时间必须大于开始时间！');
            return false;
          }
        }

        let params = JSON.parse(JSON.stringify(this.setModule));
        params.marginLeft = params.marginLeft / 2;
        params.marginTop = params.marginTop / 2;
        if (parseInt(this.status) !== 2 ) {
          params.startTime = 0;
          params.endTime = 0;
        } else {
          params.startTime = this.setModule.startTime;
          params.endTime = this.setModule.endTime;
        }

        params = Object.assign({},{'format': format}, params)

        if (params.startTime !== 0 && params.endTime !== 0) {
          params.startTime = Date.parse(params.startTime) / 1000;
          params.endTime = Date.parse(params.endTime) / 1000;
        }
        HttpRequest.post("/admin.php?method=main.doSaveTopicModule", params, true).then((response) => {
          if (response.data.success == 1) {
            this.$message('保存成功');
          } else {
            this.$message('接口错误,请联系管理员');
          }
        }, (error) => {

        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .img-rel-wrap{
        width: 300px;
        height: 180px;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
        }
      }
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .topic-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 560px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
</style>
